const validatorEmpty = (value: any) => {
  return true;
};

/**
 *
 * @param email
 *
 * origin: https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
 */
function validateEmail(email: string) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

/**
 * 
 * @param password 
 * 
 * ^	The password string will start this way
  (?=.*[a-z])	The string must contain at least 1 lowercase alphabetical character
  (?=.*[A-Z])	The string must contain at least 1 uppercase alphabetical character
  (?=.*[0-9])	The string must contain at least 1 numeric character
  (?=.[!@#\$%\^&])	The string must contain at least one special character, but we are escaping reserved RegEx characters to avoid conflict
  (?=.{6,})	The string must be six characters or longer
 * 
 * origin: https://www.thepolyglotdeveloper.com/2015/05/use-regex-to-test-password-strength-in-javascript/
 *   const strongRegex = new RegExp(
 *      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
 *    );
 */
function validatePassword(password: string) {
  const strongRegex = new RegExp("^.{6,16}$");

  return strongRegex.test(String(password));
}


function validateName(name: string) {
  const nameRegex = new RegExp("^.{3,32}$");

  return nameRegex.test(String(name));
}

function validateBoolean(value: any) {
  return !!value;
}

function validateObjectEmpty(obj: Object) {
  if (!obj) {
    return true;
  }

  if (obj.constructor !== Object) {
    return false;
  }

  return !Object.keys(obj).length;
}

function isMobileDevice() {
  return (
    // typeof window.orientation !== "undefined" ||
    navigator.userAgent.indexOf("iPhone") !== -1 ||
    navigator.userAgent.indexOf("Android") !== -1
  );
}

export {
  validatorEmpty,
  validateEmail,
  validatePassword,
  validateName,
  validateBoolean,
  validateObjectEmpty,
  isMobileDevice
};
